/**
 * Canned test shots shared by the keyboard controls (digits 1-9) and the XR
 * controller preset cycling — one table keeps desktop and headset in lockstep.
 */
export const SHOT_PRESETS: { name: string; shot: OpenGolfSim.Shot }[] = [
  { name: 'Driver',   shot: { ballSpeed: 150, verticalLaunchAngle: 13, horizontalLaunchAngle: 0, spinSpeed: 2500, spinAxis: 0 } },
  { name: '3 Wood',   shot: { ballSpeed: 120, verticalLaunchAngle: 15, horizontalLaunchAngle: 0, spinSpeed: 3200, spinAxis: 0 } },
  { name: '5 Iron',   shot: { ballSpeed: 108, verticalLaunchAngle: 22, horizontalLaunchAngle: -1, spinSpeed: 5000, spinAxis: 8 } },
  { name: '8 Iron',   shot: { ballSpeed: 80, verticalLaunchAngle: 25, horizontalLaunchAngle: 0, spinSpeed: 7500, spinAxis: 0 } },
  { name: 'Wedge',    shot: { ballSpeed: 70, verticalLaunchAngle: 28, horizontalLaunchAngle: 0, spinSpeed: 9000, spinAxis: 0 } },
  { name: 'Pitch',    shot: { ballSpeed: 40, verticalLaunchAngle: 28, horizontalLaunchAngle: -2, spinSpeed: 6000, spinAxis: -1.2 } },
  { name: 'Flop',     shot: { ballSpeed: 30, verticalLaunchAngle: 35, horizontalLaunchAngle: 0, spinSpeed: 6000, spinAxis: 0 } },
  { name: 'Chip',     shot: { ballSpeed: 20, verticalLaunchAngle: 40, horizontalLaunchAngle: 0, spinSpeed: 4000, spinAxis: 0 } },
  { name: 'Putt',     shot: { ballSpeed: 8, verticalLaunchAngle: 0, horizontalLaunchAngle: 0, spinSpeed: 0, spinAxis: 0 } },
];

const range = (min: number, max: number) => (Math.floor(Math.random() * (max - min + 1)) + min);

/** The Space-bar randomized full shot. */
export function randomTestShot(): OpenGolfSim.Shot {
  return {
    ballSpeed: range(90, 140),
    verticalLaunchAngle: range(14, 20),
    horizontalLaunchAngle: range(-2, 2),
    spinSpeed: range(2000, 6000),
    spinAxis: range(-12, 12),
  };
}
